import gql from "graphql-tag";

const REMOVE_PRICE_LIST = gql`
  mutation removePriceList($priceListId: ID!) {
    removePriceList(priceListId: $priceListId)
  }
`;

export default REMOVE_PRICE_LIST;
